import { clx } from '@medusajs/ui';
import React from 'react';

import PlaceholderImage from '@modules/common/icons/placeholder-image';

type ThumbnailProps = {
  thumbnail?: string | null;
  images?: Array<{ url?: string }> | null;
  size?: 'small' | 'medium' | 'large' | 'full' | 'square' | 'square-lg';
  className?: string;
  'data-testid'?: string;
};

const Thumbnail: React.FC<ThumbnailProps> = ({
  thumbnail,
  images,
  size = 'small',
  className,
  'data-testid': dataTestid,
}) => {
  const initialImage = thumbnail || images?.[0]?.url;

  return (
    <div
      className={clx(
        'relative aspect-[1/1] w-[90px] overflow-hidden rounded-md p-4',
        className,
        {
          'w-full': size === 'square-lg',
        }
      )}
      data-testid={dataTestid}
    >
      <ImageOrPlaceholder image={initialImage} size={size} />
    </div>
  );
};

const ImageOrPlaceholder = ({
  image,
  size,
}: Pick<ThumbnailProps, 'size'> & { image?: string }) => {
  return image ? (
    <img
      src={image}
      alt="Thumbnail"
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover object-center"
      draggable={false}
    />
  ) : (
    <div className="absolute inset-0 flex h-full w-full items-center justify-center">
      <PlaceholderImage size={size === 'small' ? 16 : 24} />
    </div>
  );
};

export default Thumbnail;
